/**
 * Wie iets deed, voor op het scherm. De api geeft de volledige naam ("Linda de Vries") als die
 * bekend is; bij afvinklijsten typt de verzorger soms ook initialen. Er werken vaak meerdere Linda's,
 * dus de naam gaat voor en de initialen staan erachter. Zonder naam blijven alleen de initialen over.
 */
export function uitgevoerdDoor(naam: string | null | undefined, initialen?: string | null): string | null {
  const n = naam?.trim() || "";
  const i = initialen?.trim() || "";
  if (n && i && n.toLowerCase() !== i.toLowerCase()) return `${n} (${i})`;
  return n || i || null;
}
